import DtoConverter from 'scripts/application/dto_converters/agent_converter';
import qconsole from 'scripts/lib/qconsole';

export default class AgentGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleRequestedEntities(agentDtos) {
    // replace all agents with those passed in
    this.context.stores.agents.set(agentDtos.map(DtoConverter.fromDto));
    this.context.stores.agents.resetLoading();
  }

  handleRequestError(errorDto) {
    qconsole.log(`Failed to fetch agents ${JSON.stringify(errorDto)}`);
  }

  handleEntity(agentDto) {
    this.context.stores.agents.addOrReplace(DtoConverter.fromDto(agentDto));
  }

  handleDelete(agentId) {
    this.context.stores.agents.remove(agentId);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/agents/agent_gateway_observer.js